import { Plus, Trash2, ArrowUp, ArrowDown } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { parseTabs } from "@/editor/overrides";

export const TabsField = ({ value, onChange }) => {
  const tabs = parseTabs(value);
  const save = (list) => onChange(JSON.stringify(list));
  const set = (i, k, v) => save(tabs.map((t, j) => (j === i ? { ...t, [k]: v } : t)));
  const move = (i, d) => { const l = [...tabs]; [l[i], l[i + d]] = [l[i + d], l[i]]; save(l); };

  return (
    <div className="space-y-3" data-testid="tabs-field">
      {tabs.map((t, i) => (
        <div key={i} className="border border-[#D9D9D6] p-2 space-y-2" data-testid={`tabs-field-item-${i}`}>
          <div className="flex gap-1">
            <Input value={t.t} placeholder={`Reiter ${i + 1}`} onChange={(e) => set(i, "t", e.target.value)} className="h-8" data-testid={`tabs-field-title-${i}`} />
            <button type="button" disabled={i === 0} onClick={() => move(i, -1)} className="p-1 disabled:opacity-30" aria-label="Nach links"><ArrowUp className="w-3.5 h-3.5" /></button>
            <button type="button" disabled={i === tabs.length - 1} onClick={() => move(i, 1)} className="p-1 disabled:opacity-30" aria-label="Nach rechts"><ArrowDown className="w-3.5 h-3.5" /></button>
            <button type="button" disabled={tabs.length === 1} onClick={() => save(tabs.filter((_, j) => j !== i))} className="p-1 text-red-600 disabled:opacity-30" aria-label="Reiter löschen" data-testid={`tabs-field-delete-${i}`}><Trash2 className="w-3.5 h-3.5" /></button>
          </div>
          <Textarea rows={3} value={t.c} placeholder="Inhalt dieses Reiters" onChange={(e) => set(i, "c", e.target.value)} data-testid={`tabs-field-content-${i}`} />
        </div>
      ))}
      {tabs.length < 10 && (
        <button type="button" onClick={() => save([...tabs, { t: `Reiter ${tabs.length + 1}`, c: "" }])}
          className="w-full py-1.5 text-xs font-bold border border-dashed border-[#888B8D] hover:border-black hover:bg-[#EFDF00] flex items-center justify-center gap-1" data-testid="tabs-field-add">
          <Plus className="w-3.5 h-3.5" /> Reiter hinzufügen
        </button>
      )}
    </div>
  );
};
